import { AvatarWithDetails, Group } from '@melio/penny';
import { Collaborator } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';

type Props = { collaborator?: Collaborator<'user'> };
export const CollaboratorDrawerHeader = ({ collaborator }: Props) => {
  const { formatMessage } = useMelioIntl();

  const headerLabel = collaborator
    ? `${collaborator.user.firstName} ${collaborator.user.lastName}`
    : formatMessage('activities.collaboratorDrawer.create.header');

  return (
    <Group data-testid="collaborator-drawer-header" variant="horizontal" spacing="xxs" alignItems="center">
      <AvatarWithDetails
        data-testid="collaborator-drawer-header-avatar-with-details"
        mainLabelProps={{ label: headerLabel }}
        avatarProps={{ name: headerLabel, size: 'medium' }}
      />
    </Group>
  );
};
